<template>
  <el-container height="auto" style="overflow:hidden;">
    <el-header style="margin:0px;padding:0px;padding-bottom:5px;height:35px;">
          <el-row type="flex" justify="end">
            <el-col :span="12">
              <el-link  style="font-size:16px;color:#409EFF" :underline="false" @click="reloadList">
                我参与的研究
                <i class="el-icon-refresh el-icon--right" style="font-size:20px;"></i>
              </el-link>
            </el-col>
            <el-col :span="12" style="text-align:right;padding-right:15px;">
              <el-input v-model="invitecode" placeholder="请输入邀请码,后回车" size="mini" style="width:200px;height:20px;"
              @keyup.enter.native="acceptinvite"
              ></el-input>
              <el-button type="primary" size="mini" @click="acceptinvite()">接受</el-button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <el-popover
                placement="bottom"
                title=""
                width="400"
                trigger="click"
                style="cursor:pointer;"
                >
                <el-input
                    placeholder="输入研究名称进行搜索"
                    prefix-icon="el-icon-search"
                    v-model="search"
                    clearable
                    >
                  </el-input>

               <el-link slot="reference" :underline="false">
                  {{(this.search != '') ?'已筛选':'筛选'}}
                  <i class="fa fa-filter" style="font-size:20px;"></i>
                </el-link>
              </el-popover>
            </el-col>
          </el-row>
        </el-header>
    <el-main style="margin:0px;padding:0px;">
      <el-table 
          v-loading="loading" 
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background=""
          :empty-text="emptytext"
          :data="filterProjectList.slice((currentPage1-1)*pageSize1,currentPage1*pageSize1)" :show-header="false">
        <el-table-column label="名称"  prop="scope.row.name">
          <template slot-scope="scope">
            <div style="vertical-align:middle;line-height:25px;">
              <el-row type="flex" align="middle">
                <el-col :span="1"><i class="fa fa-plus-square fa-2x" ></i></el-col>
                <el-col :span="18">
                <el-link type="primary" @click="openSDC(scope.row.projectid)"  style="font-size:16px;">{{scope.row.name}}</el-link>
                </el-col>
                <el-col :span="4" style="text-align:right">发起人：{{scope.row.ownername}}</el-col>
                <el-col :span="1" style="text-align:right;">
                  <i v-if="scope.row.starflag||'' != '' "  class="fa fa-star starflag_5" style="font-size:20px;cursor:pointer;" @click="flagStar(scope.row.projectid,'0')"></i>
                  <i v-else class='fa fa-star-o starflag' style="font-size:20px;cursor:pointer;" @click="flagStar(scope.row.projectid,'5')"></i>
                </el-col>
              </el-row>
              <el-row type="flex" align="middle">
                <el-col :span="1"></el-col>
                <el-col :span="22" style="font-size:15px;padding-top:10px; color:#909399;">{{scope.row.description || "无描述"}}</el-col>
                <el-col :span="1" style="text-align:right;">
                </el-col>
              </el-row>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer style="margin:0px;padding:0px;height:30px;" v-if="filterProjectList.length>3">
        <el-pagination
              background
              
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="currentPage1"
              :page-sizes="[3,5,10,20, 30, 50, 100]"
              :page-size="pageSize1"
              layout="total, sizes, prev, pager, next"
              :total="filterProjectList.length">
          </el-pagination>
      </el-footer>
  </el-container>
</template>

<script>
export default {
    data() {
      return {
        projectList: [],
        loading:true,
        emptytext:"",
        invitecode:'',
        search:'',
        sdcprojects:[],
        // 当前页
        currentPage: 1,
        // 每页多少条
        pageSize: 5,

        currentPage1: 1,
        pageSize1: 5
      }
    },
    computed:{
      filterProjectList(){
        var search = this.search;
        var list = this.projectList;
        return list.filter(function (item) {
            return item.name.toLowerCase().indexOf(search.toLowerCase()) != -1
        });
      },
      computedProject(){
        return function(projectid) {
          var sdcproject =[];
          this.sdcprojects.forEach(project => {
            if(project.rootid == projectid){
              sdcproject = project;
            }
          });
          return sdcproject;
        }
      },
    },
    mounted() {
      this.loadList();
      //this.loadSDCMenu();
      //this.sendinvitecode();
    },
    methods:{
      loadList() {
            this.loading = true;
            this.emptytext = " ";
            this.$http.get('project/list',{params:{mode:1}}).then((res) => {
              if(!res) return;
              this.projectList = res.data.list;
              this.loading = false;
              this.emptytext="";
              });                                                  
        },
      reloadList(){
        this.loadList();
      },

      editProject(projectID) {
        this.$router.push({ path: '/project/edit', query:{id: projectID}})
      },

      delProject(projectID) {
        this.$confirm("确定要删除研究吗？", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.$http.post('project/delete', {'id':projectID}).then((res) => { 
                this.loadList();
                  }); 
            });
      },

      openSDC(projectID,url){
        this.$http.get('project/open',{params:{id:projectID+'',url:url}}).then((res) => {
              if(!res) return;
                window.open(res.data.token);
              });
      },

      acceptinvite()
      {
          this.$confirm("确定要接受邀请吗？", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.$http.post('project/acceptinvite', {'invitecode':this.invitecode}).then((res) => {

                 
                  
                  this.$message({ type:'success', message:'欢迎加入《'+ res.data.projectinfo.name +'》研究。'})
                
                  this.invitecode ='';
                  this.loadList();
                  }); 
            });
      },

      handleSelect(index, indexPath) {
        var projectid = indexPath[0].substring(indexPath[0].indexOf("$")+1,indexPath[0].length);
        //console.log(projectid, index, indexPath);
        this.openSDC(projectid,index);
      },

      sendinvitecode()
      {
// {params:
//               {
//                 inviteid:1234,
//                 sentby:3,
//                 projectid:3,
//                 email:"james.jyj@aliyun.com",

//               }
        
         this.$http.post('openserver/sendinvite',
            {
              'invitationid':'12341234',
              'sentby':'3',
              'projectrootid':'3',
              'mode':'sms',
              'receiver':'13093766887',
            }
            ).then((res) => {
              if(!res) return;
              
            });   
      },

      // 每页多少条
      handleSizeChange(val) {
          this.pageSize = val;
      },
      // 当前页
      handleCurrentChange(val) {
          this.currentPage = val;
      },

      // 每页多少条
      handleSizeChange1(val) {
          this.pageSize1 = val;
      },
      // 当前页
      handleCurrentChange1(val) {
          this.currentPage1 = val;
      },

      flagStar(projectid,starflag){
        this.$http.post('project/flagstar', {'projectid':projectid,'starflag':starflag}).then((res) => { 
          this.loadList();
        }); 
      },
    }
  };
</script>

<style lang="less" scoped>
  /deep/ .el-table tbody tr:hover>td { background-color: #ffffff!important;}
</style>